import { createApi } from '@reduxjs/toolkit/query/react'
import { createPublicApiBaseQuery } from './apiClients'

export const configApi = createApi({
    reducerPath: 'configApi',
    baseQuery: createPublicApiBaseQuery('configApi', { baseUrl: `${process.env.REACT_APP_API_BASE_URL}/configs` }),
    tagTypes: ['Configs'],
    endpoints: (builder) => ({
        getConfigs: builder.query({
            query: () => '',
            transformResponse: (response) => response,
            transformErrorResponse: (response) => response,
            providesTags: ['Configs']
        }),
    }),
})

export const { useGetConfigsQuery } = configApi
